import { bookSort } from "./bookManage.js";

export function is_weixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

export function check_browser() {
  if (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/iPad/i)
  ) {
    return "iphone";
  } else if (navigator.userAgent.match(/Android/i)) {
    return "android";
  } else {
    return "pc";
  }
}

// 处理图书
const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    // 如果 result 中没有这个 key，则创建一个空数组
    if (!result[currentValue[key]]) {
      result[currentValue[key]] = [];
    }
    // 将当前对象 push 到对应的 key 数组中
    result[currentValue[key]].push(currentValue);
    return result;
  }, {}); // 初始值是一个空对象
};
export function handleBookList(list) {
  list.forEach((item) => {
    const obj = bookSort[item.book_id];
    if (obj && Object.keys(obj).length) {
      item.series = obj.series;
      item.book_ico = require(`@/assets/images/book_cover/${obj.imgName}`);
    }
  });
  // 使用 groupBy 函数按 'series' 属性分组
  const finalJson = groupBy(list, "series");
  console.log("处理过的图书列表", finalJson);
  return finalJson;
}
